var FontFamilyHelper = /** @class */ (function () {
    function FontFamilyHelper() {
    }
    FontFamilyHelper.getFontFamilies = function () {
        return FontFamilyHelper.fontFamilies;
    };
    FontFamilyHelper.defautFontFamily = 'Microsoft YaHei';
    FontFamilyHelper.fontFamilies = [
        { value: 'Microsoft YaHei', label: 'MicrosoftYaHei' },
        { value: 'SimSun', label: 'SimSun' },
        { value: 'KaiTi', label: 'KaiTi' },
        { value: 'LiSu', label: 'LiSu' },
        { value: 'SimHei', label: 'SimHei' },
    ];
    return FontFamilyHelper;
}());
export { FontFamilyHelper };
